import { useState } from 'react';
import { faqs } from '@/mocks/home';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="faq" className="w-full bg-secondary-50 border-y border-secondary-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
          <div className="lg:col-span-4">
            <div className="text-[11px] tracking-[0.3em] text-secondary-700 mb-3">常见问题</div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-5">
              先把你会问的，写在这里
            </h2>
            <p className="text-sm leading-relaxed text-foreground-600 mb-8">
              我们只做视觉细节的整理与对照：标明来源、标出差异、保留不确定。不提供原始文件，也不替你做任何判断。
            </p>
            <div className="flex flex-col gap-4">
              <div className="flex items-start gap-3">
                <span className="w-6 h-6 flex items-center justify-center rounded-md bg-secondary-200 text-secondary-900 shrink-0">
                  <i className="ri-shield-check-line text-sm"></i>
                </span>
                <p className="text-sm text-foreground-700 leading-relaxed">条目标注来源与时间，可回溯</p>
              </div>
              <div className="flex items-start gap-3">
                <span className="w-6 h-6 flex items-center justify-center rounded-md bg-secondary-200 text-secondary-900 shrink-0">
                  <i className="ri-file-list-3-line text-sm"></i>
                </span>
                <p className="text-sm text-foreground-700 leading-relaxed">待核对状态如实保留，不硬下结论</p>
              </div>
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="rounded-lg border border-secondary-200/70 bg-background-50 overflow-hidden">
              {faqs.map((faq, index) => {
                const isOpen = index === openIndex;
                return (
                  <div
                    key={faq.q}
                    className={index !== 0 ? 'border-t border-background-200/70' : undefined}
                  >
                    <button
                      type="button"
                      onClick={() => setOpenIndex(isOpen ? -1 : index)}
                      className="w-full flex items-center justify-between gap-4 text-left px-5 md:px-6 py-5 cursor-pointer"
                    >
                      <span className="font-heading text-base md:text-lg font-bold text-foreground-950">
                        {faq.q}
                      </span>
                      <span
                        className={
                          'w-7 h-7 flex items-center justify-center rounded-full border shrink-0 transition-colors ' +
                          (isOpen
                            ? 'bg-primary-500 border-primary-500 text-background-50'
                            : 'border-background-300 text-foreground-600')
                        }
                      >
                        <i className={isOpen ? 'ri-subtract-line text-sm' : 'ri-add-line text-sm'}></i>
                      </span>
                    </button>
                    {isOpen && (
                      <div className="px-5 md:px-6 pb-6 -mt-1">
                        <p className="text-sm leading-relaxed text-foreground-600 max-w-2xl">{faq.a}</p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}